import { SVGProps } from "react"

export const ClockCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M8 0.999985C4.13438 0.999985 1 4.13436 1 7.99998C1 11.8656 4.13438 15 8 15C11.8656 15 15 11.8656 15 7.99998C15 4.13436 11.8656 0.999985 8 0.999985ZM8 13.8125C4.79063 13.8125 2.1875 11.2094 2.1875 7.99998C2.1875 4.79061 4.79063 2.18748 8 2.18748C11.2094 2.18748 13.8125 4.79061 13.8125 7.99998C13.8125 11.2094 11.2094 13.8125 8 13.8125Z"
      fill="#111827"/>
    <path
      d="M10.7297 9.97809L8.50156 8.36716V4.49998C8.50156 4.43123 8.44531 4.37498 8.37656 4.37498H7.625C7.55625 4.37498 7.5 4.43123 7.5 4.49998V8.8031C7.5 8.84372 7.51875 8.88122 7.55156 8.90466L10.1359 10.789C10.1922 10.8297 10.2703 10.8172 10.3109 10.7625L10.7578 10.1531C10.7984 10.0953 10.7859 10.0172 10.7297 9.97809Z"
      fill="#111827"/>
  </svg>)
